import React, { useState } from "react";
import logo from "../../assets/images/logotalent.png";
import GeneralMUIDialog from "../../components/GeneralMUIDialog/GeneralMUIDialog";
import { web_url } from "../../config/config";
import { useNavigate } from "react-router-dom";

export default function Footer({ isFullWidthFooter = true }) {
  const navigate = useNavigate();

  return <></>;
}
